import EventModalMediaContent from '../../../../../components/EventModalMediaContent';
import { useOrderContext } from '../../../../../providers/OrderProvider';

const OrderBusinessDetail = () => {
	const { order } = useOrderContext();

	return (
		<EventModalMediaContent icon='building' heading='商务信息'>
			<div className='d-flex flex-column gap-1'>
				<p className='mb-0 fs-10 fw-normal'>
					到货时间：<span className='text-primary'>{order?.arrivalTime || '-'}</span>
				</p>
				<p className='mb-0 fs-10 fw-normal'>
					保修期：<span className='text-primary'>{order?.warrantyPeriod != null ? `${order.warrantyPeriod} 年` : '-'}</span>
				</p>
				{order?.paymentExplain ? (
					<p className='mb-0 fs-10 fw-normal'>
						付款说明：<span className='text-primary'>{order.paymentExplain}</span>
					</p>
				) : null}
			</div>
		</EventModalMediaContent>
	);
};

export default OrderBusinessDetail;
